import EmbedSnippet from '@calcom/embed-snippet';

export type UseCalcomEmbedReturn = Ref<ReturnType<typeof EmbedSnippet> | undefined>;

export default function useCalcomEmbed(embedJsUrl?: MaybeRefOrGetter<string | undefined>): UseCalcomEmbedReturn {
    const globalCal = ref<ReturnType<typeof EmbedSnippet>>();

    onMounted(() => {
        globalCal.value = EmbedSnippet(toValue(embedJsUrl));
    });

    return globalCal;
}
